import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-rating-stars',
  templateUrl: './rating-stars.component.html',
  styleUrls: ['./rating-stars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingStarsComponent implements OnInit {
  @Input() clickable: boolean;
  @Input() ratingValue: number;
  @Output() ratingValueChange = new EventEmitter<number>();
  @Input() ratingStarsSize?: 'sm' | 'lg';

  displayedValueAttribute = 0;
  readonly grades = [1, 2, 3, 4, 5];

  constructor() { }

  ngOnInit(): void {
    this.roundToRatingValueQuarters();
  }

  setGrade(grade: number): void {
    this.ratingValueChange.emit(grade);
    this.displayedValueAttribute = grade;
  }

  private roundToRatingValueQuarters(): void {
    this.displayedValueAttribute =
      (Math.round(this.ratingValue * 4) / 4);
  }
}
